import tw from "twin.macro";

export const Icon = tw.img`
  object-contain
`;
